import CircularProgress, {
  CircularProgressProps,
} from '@material-ui/core/CircularProgress';
import { useStyles } from './style';
import { themeInstance } from 'configs/theme';
import clsx from 'clsx';

type Custom = typeof themeInstance.custom;

type CustomColor = keyof Custom;

interface Props {
  themeColor?: CustomColor;
  cls?: {
    root?: string;
  };
}

const Loader: React.FC<Props & CircularProgressProps> = ({
  themeColor,
  cls,
  ...rest
}) => {
  const cssProps = {
    color: themeColor ? themeInstance.custom[themeColor] : '#fff',
  };
  const classes = useStyles(cssProps);

  return (
    <CircularProgress
      {...rest}
      className={clsx(classes.root, cls?.root)}
      color="inherit"
    />
  );
};

export default Loader;
